import React from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import { Box, Typography } from '@mui/material';

const DownloadReportButton = ({ onClick, disabled = false }) => {
  return (
    <Box
      onClick={disabled ? undefined : onClick}
      sx={{
        border: '2px dashed #ccc',
        borderRadius: '8px',
        width: '200px',
        height: '120px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        backgroundColor: disabled ? '#f5f5f5' : 'transparent',
        '&:hover': {
          backgroundColor: disabled ? '#f5f5f5' : '#f5f5f5',
        },
      }}
    >
      <DownloadIcon sx={{ fontSize: 30, mb: 1, color: disabled ? '#999' : 'inherit' }} />
      <Typography variant="body1" fontWeight="500" sx={{ color: disabled ? '#999' : 'inherit' }}>
        {disabled ? 'Generating...' : 'Download report'}
      </Typography>
    </Box>
  );
};

export default DownloadReportButton;
